<script setup lang="ts">
import {onErrorCaptured, provide, readonly, ref} from 'vue';
import {phraseContextKey} from './keys';
import {AppComponent} from './composition/use-apps';
import {type AppContext, appContextKey} from "@hantera/portal-app";


const props = defineProps<{
  appComponent: AppComponent
}>();

provide(phraseContextKey, 'apps.' + props.appComponent.appContext.appId);
provide(appContextKey, readonly<AppContext>(props.appComponent.appContext))

const error = ref<{
  component: string
  message: Error
}>();

onErrorCaptured((err, instance) => {
  error.value = {
    component: instance?.$.type.__name ?? 'unknown',
    message: err
  };
  console.error(err)

  return process.env.NODE_ENV === 'development'
})
</script>

<template>
  <div v-if="error" class="app-component-error">
    <h2>Error in '{{error.component}}' from app '{{appComponent.appContext.appId}}'</h2>
    
    <p>
      {{ error.message }}
    </p>
  </div>
  <Suspense v-else>
    <component :is="appComponent.component" />
  </Suspense>
</template>

<style scoped>
.app-component-error {
  background-color: var(--color-error-100);
  border: 1px solid var(--color-error-25);
  padding: 5px;
}

.app-component-error h2 {
  font-size: 16px;
  font-weight: bold;
  margin: 5px 0;
}

.app-component-error p {
  margin: 5px 0;
}
</style>